import React, { Component } from 'react';

import { withRouter } from "react-router-dom";

import "../design/projecttasks.css";

class TaskCommentList extends Component {

    render() {
        const comments = this.props.Comments;
        if (!comments) return null;

        return (
            <div>

                <table>
                    <thead>
                        <tr>
                            <td>Task Comment(s)</td>
                        </tr>
                    </thead>
                    <tbody>
                        {comments.map((comment) => (
                            <tr className="tr_hover"
                                key={comment.taskCommentUUID}>
                                <td>{comment.commentText}</td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>
        )
    }
}

export default withRouter(TaskCommentList);


// WEBPACK FOOTER //
// ./src/components/taskCommentList.js